export default ({ config }) => ({
  component: 'AsyncSelectFilter',
  componentAttrs: {
    config,
  },
});
